import { generateUtilityClass, generateUtilityClasses } from '../className';
export function getCheckboxUtilityClass(slot) {
  return generateUtilityClass('JoyCheckbox', slot);
}
const checkboxClasses = generateUtilityClasses('JoyCheckbox', ['root', 'checkbox', 'action', 'input', 'label', 'checked', 'disabled', 'focusVisible', 'indeterminate', 'colorPrimary', 'colorDanger', 'colorInfo', 'colorNeutral', 'colorSuccess', 'colorWarning', 'sizeSm', 'sizeMd', 'sizeLg', 'variantOutlined', 'variantSoft', 'variantSolid']);
export default checkboxClasses;